import React from 'react';
import PropTypes from 'prop-types';
import SearchTools from 'chameleon/ui-stack/ui/basic/search-tools';
import SearchTipsButton from 'chameleon/ui-stack/ui/buttons/search-tips';
import GuideModal from '../GuideModal';

const SearchControl = (props) => {
  const {
    initSearch,
    searchTerm,
    setSearchTerm,
    pushParamsToHistory,
    onSearch,
    outlineSearchInstructionalResourceSearchText,
  } = props;
  const isSearchTextEmpty = searchTerm.length === 0;

  const onSearchButtonClick = () => {
    if (!initSearch) {
      pushParamsToHistory({
        searchTerm,
      });
    }

    onSearch(searchTerm);
  };

  const onClearText = () => {
    setSearchTerm('');

    if (!initSearch) {
      pushParamsToHistory({ searchTerm: '' });
    }
  };

  const onInputKeyPress = ({ which, keyCode }) =>
    (which || keyCode) === 13 && onSearchButtonClick();

  //
  return (
    <SearchTools
      isPrimary
      inputPlaceholder="Search all unit resources by content or keywords..."
      text={searchTerm}
      onClearText={onClearText}
      isSearchTextEmpty={isSearchTextEmpty}
      onInputKeyPress={onInputKeyPress}
      onSearchButtonClick={onSearchButtonClick}
      setText={setSearchTerm}
      searchTipsButton={
        <GuideModal
          button={<SearchTipsButton isLink />}
          outlineSearchInstructionalResourceSearchText={
            outlineSearchInstructionalResourceSearchText
          }
        />
      }
    />
  );
};

SearchControl.propTypes = {
  initSearch: PropTypes.bool,
  searchTerm: PropTypes.string,
  pushParamsToHistory: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  isStudent: PropTypes.bool,
  outlineSearchInstructionalResourceSearchText: PropTypes.bool,
};

SearchControl.defaultProps = {
  initSearch: false,
  searchTerm: '',
  onSearch: () => {},
  isStudent: false,
  outlineSearchInstructionalResourceSearchText: false,
};

export default SearchControl;
